<ng-template id="multiCountryTemplate" #multiCountryTemplate bsModal class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="multiCountryTemplate" aria-hidden="true">
    <form [formGroup]="downlaodMultiCountry" (ngSubmit)="downloadMultiCountryPDF(downlaodMultiCountry.value)" novalidate>
        <div class="modal-header bg-info text-white">
            <p class="modal-title">
                <strong class="mr-1">Select the location(s) to download a PDF</strong>
            </p>
            <button type="button" class="btn btn-sm btn-info" aria-label="Close" (click)="closePopup()">
                <span aria-hidden="true"><i class="fa fa-close"></i></span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row row--content user-content">
                <div class="col-md-12">
                    <label class="form-label" style="font-weight: 900;">Select the location(s) you would like to be downloaded for</label><br>
                    <div class="row" style="margin-left: -15px; overflow-y: auto; max-height: 135px;" [formGroup]="getUserCountriesFormGroup()">
                        <div class="col-md-12">
                            <input type="checkbox" id="selectAll" value="false" [checked]="selectAll" (change)="selectAllCountries($event)">
                            <label for="selectAll" style="font-weight: 400; margin-left: 8px;">Select all location(s)</label>
                        </div>
                        @for (geo of cData; track geo) {
                        <div class="col-md-4" style="display: flex;align-items: center;">
                            <input type="checkbox" id="{{geo.id}}" value="{{geo.id}}" style="margin-bottom: 10px;" [formControlName]="geo.id" (change)="onCheckboxChange($event)">
                            <label for="{{geo.id}}" style="font-weight: 400; margin-left: 5px;">{{geo.shortName}} </label>
                        </div>
                        }
                    </div>
                    @if (selectedCountry<2 && submitted) {
            <div class="alert alert-danger">
              Please select at least two location(s).
            </div>
          }
                </div>
            </div>

            <div class="md-3">
                <div class="row">
                    <div class="col-md-4">
                        <button type="submit" class="btn btn-info">Download PDF</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>
<downloadfile #downloadmulticontries></downloadfile>